const API_BASE = '/api';

export const fetchProducts = async () => {
    const res = await fetch(`${API_BASE}/products`);
    if (!res.ok) throw new Error('Ошибка загрузки товаров');
    return res.json();
};

export const sendChatMessage = async (message, userId) => {
    const res = await fetch(`${API_BASE}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message, user_id: userId }),
    });
    if (!res.ok) throw new Error('Ошибка чата');
    return res.json();
};

// НОВОЕ: создание заказа через Т-Банк
export const createOrder = async (payload) => {
    const res = await fetch(`${API_BASE}/orders/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        const text = await res.text();
        throw new Error(text || 'Ошибка создания заказа');
    }
    return res.json();
};

// Старая заглушка — можно оставить для обратной совместимости
export const createPayment = async (amount, description, returnUrl) => {
    const res = await fetch(`${API_BASE}/create-payment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount, description, return_url: returnUrl }),
    });
    if (!res.ok) throw new Error('Ошибка создания платежа');
    return res.json();
};

export const fetchPickupPoints = async (network, city) => {
    const res = await fetch(`${API_BASE}/pickup-points?network=${encodeURIComponent(network)}&city=${encodeURIComponent(city)}`);
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Не удалось загрузить пункты выдачи');
    }
    return res.json();
};

export const fetchActiveCartPromotions = async () => {
    const res = await fetch(`${API_BASE}/promotions/active`);
    if (!res.ok) return [];
    return res.json();
};

// ─── Избранное ───
export const fetchWishlist = async () => {
    const r = await fetch('/api/account/wishlist', { credentials: 'include' });
    if (!r.ok) return { product_ids: [] };
    return r.json();
};

export const saveWishlist = async (productIds) => {
    const r = await fetch('/api/account/wishlist', {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_ids: productIds }),
    });
    if (!r.ok) throw new Error('Не удалось сохранить избранное');
    return r.json();
};